<template>
    <p v-if="errors && errors[field] && errors[field][0]" :id="`${field}_feedback`" class="text-danger form-text">
        {{ errors[field][0] }}
    </p>
</template>

<script setup>
const props = defineProps({
    errors: {
        type: Object,
    },
    field: {
        type: String,
        required: true,
    },
})

</script>
